
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points forts?`}</em></p>
    <p>{`Par rapport au vaccin d’AstraZeneca, qui utilise la même technologie, les études
ont révélé une efficacité plus élevée.`}</p>
    <p>{`Les chercheurs russes ont en outre eu une idée ingénieuse, celle de changer de
vecteur entre les deux doses, pour éviter une réponse de notre système
immunitaire contre le vecteur lors de la deuxième injection.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;